import { render, staticRenderFns } from "./ReferralForm.vue?vue&type=template&id=d945cad4"
import script from "./ReferralForm.vue?vue&type=script&lang=js"
export * from "./ReferralForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports